import {
  AlertDialog,
  AlertDialogTrigger,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogAction,
  AlertDialogCancel,
} from "components/ui/alert-dialog";
import { Button } from "components/ui/button";
import { Loader, Loader2 } from "lucide-react";

export function AlertDialogCom({
  alertTitle,
  alertDescription,
  handleSubmit,
  nameSubmitButton,
  loading,
  children,
}: {
  alertTitle: string;
  alertDescription: string;
  handleSubmit: () => void;
  nameSubmitButton: string;
  loading?: boolean;
  children: React.ReactNode;
}) {
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>{children}</AlertDialogTrigger>
      <AlertDialogContent className="max-w-md p-6 bg-white dark:bg-background border-gray-200 rounded-3xl shadow-2xl border transition-all duration-300 ease-in-out">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-xl font-bold ">
            {alertTitle}
          </AlertDialogTitle>
          <AlertDialogDescription className="text-sm text-muted-foreground mt-2">
            {alertDescription}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex justify-end space-x-4 mt-4">
          <AlertDialogCancel className="px-4 py-2 text-muted-foreground bg-secondary rounded-xl hover:bg-gray-200 dark:bg-background transition-all duration-300 ease-in-out">
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction
            className="px-5 py-2 text-white bg-gradient-to-r from-blue-500 to-indigo-600 rounded-xl shadow-md hover:scale-105 hover:shadow-lg transition-all duration-300 ease-in-out flex items-center gap-2"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? (
              <Loader className="animate-spin w-5 h-5" />
            ) : (
              nameSubmitButton
            )}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
